import React from "react";
import FormField from "./FormField";

export default function TextInputField({
  id,
  name,
  label,
  value,
  onChange,
  placeholder,
  autoComplete,
  error,
  styles,
  inputClassName,
  readOnly,
}) {
  return (
    <FormField label={label} htmlFor={id} error={error} styles={styles}>
      <input
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        readOnly={readOnly}
        className={error ? styles?.inputError : inputClassName}
      />
    </FormField>
  );
}
